export const sagaActions = {
  API_CALL_START: "API_CALL_START",
  API_CALL_END: "API_CALL_END",
  API_FAILED: "API_FAILED",

  SPICES_LOAD: "SPICES_LOAD",
  SPICES_LOAD_REQUEST: "SPICES_LOAD_REQUEST",

  INCENSES_LOAD_REQUEST: "INCENSES_LOAD_REQUEST",
  INCENSES_LOAD: "INCENSES_LOAD",

  HOME_LOOKUPS_LOAD_REQUEST: "HOME_LOOKUPS_LOAD_REQUEST",
  HOME_LOOKUPS_LOAD: "HOME_LOOKUPS_LOAD",

  CONTACTS_LOAD_REQUEST: "CONTACTS_LOAD_REQUEST",
  CONTACTS_LOAD: "CONTACTS_LOAD",

  ORDERS_LOAD: "ORDERS_LOAD",
  ORDERS_LOAD_REQUEST: "ORDERS_LOAD_REQUEST",

  ORDERS_POST: "ORDERS_POST",
  ORDERS_POST_REQUEST: "ORDERS_POST_REQUEST",
  ORDERS_POSTED: "ORDERS_POSTED",
  ORDERS_FAILED: "ORDERS_FAILED",
  ORDERS_RESET: "ORDERS_RESET",
};
